import { useEffect, useState } from 'react';
import { resolveVisualViewport, type VisualViewport } from './visualViewport';

/**
 * Classifies viewport for graph/grid surfaces.
 * phone ≤767 · tablet 768–1023 · desktop ≥1024
 */
export function useVisualViewport(): VisualViewport {
  const [viewport, setViewport] = useState<VisualViewport>(() => {
    if (typeof window === 'undefined') return 'desktop';
    return resolveVisualViewport(window.innerWidth);
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const update = () => setViewport(resolveVisualViewport(window.innerWidth));
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  return viewport;
}

export function useVisualViewportFlags() {
  const viewport = useVisualViewport();
  return {
    viewport,
    isPhone: viewport === 'phone',
    isTablet: viewport === 'tablet',
    isDesktop: viewport === 'desktop',
    isCompact: viewport !== 'desktop',
  } as const;
}
